import { Button, ButtonProps, Tooltip } from "antd";
import { SizeType } from "antd/es/config-provider/SizeContext";
import React, { FC } from "react";

export type ButtonType =
  | "text"
  | "link"
  | "default"
  | "primary"
  | "dashed"
  | "light";

export type ButtonUIProps = {
  icon?: React.ReactNode;
  type?: ButtonType;
  size?: SizeType;
  className?: string;
  name?: string;
  title?: string | React.ReactNode;
  block?: boolean;
  style?: React.CSSProperties;
  isDisabled?: boolean;
  isLoading?: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
  htmlType?: "submit";
} & Omit<ButtonProps, "type" | "title">;

export const ButtonUI: FC<ButtonUIProps> = ({
  children,
  icon,
  block,
  className,
  name,
  onClick,
  title,
  style,
  size,
  type = "primary",
  isLoading,
  isDisabled,
  ...props
}) => {
  const getButtonType = (type: ButtonType) => {
    if (type === "light") return "text";
    return type;
  };

  const getBackground = (type: ButtonType) => {
    return type === "light"
      ? "rgba(0, 0, 0, 0.06)"
      : type === "text"
        ? ""
        : "#1c1c1ce4";
  };

  return (
    <Tooltip title={title}>
      <Button
        className={className}
        onClick={onClick}
        size={size}
        name={name}
        block={block}
        style={{
          background: getBackground(type),
          ...style,
        }}
        disabled={isDisabled}
        loading={isLoading}
        type={getButtonType(type)}
        icon={icon}
        {...props}
      >
        {children}
      </Button>
    </Tooltip>
  );
};
